import { GALLAGHER_TWX_DATA_LOGGER_CONFIG } from "constants/actionTypes";

export function reportGallagherTwxDataLoggerConfigFailed(deviceId: string) {
  return {
    type: GALLAGHER_TWX_DATA_LOGGER_CONFIG.FAILURE,
    deviceId,
  };
}
